import { S3RootDto } from '../routes/products/edit/files/store/S3Files';
import ApiHttpClient from './ApiHttpClient';

export default class Utils {
  constructor(private readonly client: ApiHttpClient) {}

  async uploadFile(file: File): Promise<string> {
    return this.client.post(`v1/provider/utils/uploadFile`, file);
  }

  async listS3Path(url: string): Promise<S3RootDto> {
    return this.client.post(`v1/provider/utils/listS3Path`, { url });
  }

  getBillingUrl(
    providerId: string | undefined,
    startDate: string,
    endDate: string,
  ): string {
    const apiBaseUrl = this.client.baseUrl;

    if (providerId) {
      const url = new URL(`v1/admin/billing/bill.html`, apiBaseUrl);
      url.searchParams.append('providerId', providerId);
      url.searchParams.append('startDate', startDate);
      url.searchParams.append('endDate', endDate);

      return url.href;
    }

    const url = new URL(`v1/admin/billing/bills.zip`, apiBaseUrl);
    url.searchParams.append('startDate', startDate);
    url.searchParams.append('endDate', endDate);
    return url.href;
  }
}
